/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssetUploadResponse } from '../models/AssetUploadResponse';
import type { ConnectedAppsResponse } from '../models/ConnectedAppsResponse';
import type { ConsentDecisionRequest } from '../models/ConsentDecisionRequest';
import type { ConsentDecisionResponse } from '../models/ConsentDecisionResponse';
import type { ConsentInfoRequest } from '../models/ConsentInfoRequest';
import type { ConsentInfoResponse } from '../models/ConsentInfoResponse';
import type { CreateBoardImagePinRequest } from '../models/CreateBoardImagePinRequest';
import type { CreateBoardImagePinResponse } from '../models/CreateBoardImagePinResponse';
import type { CreateBoardRequest } from '../models/CreateBoardRequest';
import type { CreateBoardResponse } from '../models/CreateBoardResponse';
import type { CreateDiffusionJobInfoRequest } from '../models/CreateDiffusionJobInfoRequest';
import type { CreateDiffusionJobInfoResponse } from '../models/CreateDiffusionJobInfoResponse';
import type { CreateEarlyAccessInviteRequest } from '../models/CreateEarlyAccessInviteRequest';
import type { CreateEarlyAccessInviteResponse } from '../models/CreateEarlyAccessInviteResponse';
import type { CreateGraphProjectRequest } from '../models/CreateGraphProjectRequest';
import type { CreateGraphProjectResponse } from '../models/CreateGraphProjectResponse';
import type { CreateJourneyRequest } from '../models/CreateJourneyRequest';
import type { CreateJourneyResponse } from '../models/CreateJourneyResponse';
import type { CreateMaterialRequest } from '../models/CreateMaterialRequest';
import type { CreateMaterialResponse } from '../models/CreateMaterialResponse';
import type { CreatePromptAddendumRequest } from '../models/CreatePromptAddendumRequest';
import type { CreatePromptAddendumResponse } from '../models/CreatePromptAddendumResponse';
import type { CreateSnapshotRequest } from '../models/CreateSnapshotRequest';
import type { CreateSnapshotResponse } from '../models/CreateSnapshotResponse';
import type { CreateUploadedImageRequest } from '../models/CreateUploadedImageRequest';
import type { CreateUploadedImageResponse } from '../models/CreateUploadedImageResponse';
import type { DeleteBoardImagePinRequest } from '../models/DeleteBoardImagePinRequest';
import type { DeleteBoardImagePinResponse } from '../models/DeleteBoardImagePinResponse';
import type { DeleteBoardRequest } from '../models/DeleteBoardRequest';
import type { DeleteBoardResponse } from '../models/DeleteBoardResponse';
import type { DeleteChatSessionResponse } from '../models/DeleteChatSessionResponse';
import type { DeleteGraphProjectResponse } from '../models/DeleteGraphProjectResponse';
import type { DeleteJourneyRequest } from '../models/DeleteJourneyRequest';
import type { DeleteJourneyResponse } from '../models/DeleteJourneyResponse';
import type { DeletePromptAddendumRequest } from '../models/DeletePromptAddendumRequest';
import type { DeletePromptAddendumResponse } from '../models/DeletePromptAddendumResponse';
import type { DeleteSnapshotResponse } from '../models/DeleteSnapshotResponse';
import type { DuplicateProjectRequest } from '../models/DuplicateProjectRequest';
import type { DuplicateSnapshotRequest } from '../models/DuplicateSnapshotRequest';
import type { DuplicateSnapshotResponse } from '../models/DuplicateSnapshotResponse';
import type { ExportPresetWrite } from '../models/ExportPresetWrite';
import type { GetBetaInfoResponse } from '../models/GetBetaInfoResponse';
import type { GetBoardImagePinsResponse } from '../models/GetBoardImagePinsResponse';
import type { GetBoardImagesResponse } from '../models/GetBoardImagesResponse';
import type { GetBoardResponse } from '../models/GetBoardResponse';
import type { GetBoardsResponse } from '../models/GetBoardsResponse';
import type { GetChatMessagesResponse } from '../models/GetChatMessagesResponse';
import type { GetChatSessionsResponse } from '../models/GetChatSessionsResponse';
import type { GetEarlyAccessCodesResponse } from '../models/GetEarlyAccessCodesResponse';
import type { GetEarlyAccessInvitesResponse } from '../models/GetEarlyAccessInvitesResponse';
import type { GetGeneratedImagesResponse } from '../models/GetGeneratedImagesResponse';
import type { GetGeneratedPointCloudResponse } from '../models/GetGeneratedPointCloudResponse';
import type { GetGeneratedPointCloudsResponse } from '../models/GetGeneratedPointCloudsResponse';
import type { GetGlbFileResponse } from '../models/GetGlbFileResponse';
import type { GetGraphProjectResponse } from '../models/GetGraphProjectResponse';
import type { GetGraphProjectsResponse } from '../models/GetGraphProjectsResponse';
import type { GetJourneyResponse } from '../models/GetJourneyResponse';
import type { GetJourneysResponse } from '../models/GetJourneysResponse';
import type { GetMaterialsResponse } from '../models/GetMaterialsResponse';
import type { GetPlanInformationResponse } from '../models/GetPlanInformationResponse';
import type { GetPresetsResponse } from '../models/GetPresetsResponse';
import type { GetPromptAddendumsResponse } from '../models/GetPromptAddendumsResponse';
import type { GetSnapshotResponse } from '../models/GetSnapshotResponse';
import type { GetSnapshotsResponse } from '../models/GetSnapshotsResponse';
import type { GetTrashedSnapshotsResponse } from '../models/GetTrashedSnapshotsResponse';
import type { GetUploadedImagesResponse } from '../models/GetUploadedImagesResponse';
import type { GetUserSettingsResponse } from '../models/GetUserSettingsResponse';
import type { GetVoxFileResponse } from '../models/GetVoxFileResponse';
import type { InvitationCreate } from '../models/InvitationCreate';
import type { InvitationTokenAccept } from '../models/InvitationTokenAccept';
import type { MembershipRoleUpdate } from '../models/MembershipRoleUpdate';
import type { PatchBoardRequest } from '../models/PatchBoardRequest';
import type { PatchBoardResponse } from '../models/PatchBoardResponse';
import type { PatchGeneratedImagesRequest } from '../models/PatchGeneratedImagesRequest';
import type { PatchGeneratedImagesResponse } from '../models/PatchGeneratedImagesResponse';
import type { PatchGeneratedPointCloudsRequest } from '../models/PatchGeneratedPointCloudsRequest';
import type { PatchGeneratedPointCloudsResponse } from '../models/PatchGeneratedPointCloudsResponse';
import type { PatchJourneyRequest } from '../models/PatchJourneyRequest';
import type { PatchJourneyResponse } from '../models/PatchJourneyResponse';
import type { PatchMaterialsRequest } from '../models/PatchMaterialsRequest';
import type { PatchMaterialsResponse } from '../models/PatchMaterialsResponse';
import type { PatchPresetUserSettingsRequest } from '../models/PatchPresetUserSettingsRequest';
import type { PatchPresetUserSettingsResponse } from '../models/PatchPresetUserSettingsResponse';
import type { PatchPromptAddendumRequest } from '../models/PatchPromptAddendumRequest';
import type { PatchPromptAddendumResponse } from '../models/PatchPromptAddendumResponse';
import type { PatchUploadedImagesRequest } from '../models/PatchUploadedImagesRequest';
import type { PatchUploadedImagesResponse } from '../models/PatchUploadedImagesResponse';
import type { PatchUserSettingsRequest } from '../models/PatchUserSettingsRequest';
import type { PatchUserSettingsResponse } from '../models/PatchUserSettingsResponse';
import type { RedeemEarlyAccessCodeRequest } from '../models/RedeemEarlyAccessCodeRequest';
import type { RedeemEarlyAccessCodeResponse } from '../models/RedeemEarlyAccessCodeResponse';
import type { RenameGraphProjectRequest } from '../models/RenameGraphProjectRequest';
import type { RenameGraphProjectResponse } from '../models/RenameGraphProjectResponse';
import type { RestoreProjectFromSnapshotRequest } from '../models/RestoreProjectFromSnapshotRequest';
import type { RestoreProjectFromSnapshotResponse } from '../models/RestoreProjectFromSnapshotResponse';
import type { RestoreProjectRequest } from '../models/RestoreProjectRequest';
import type { RestoreProjectResponse } from '../models/RestoreProjectResponse';
import type { RestoreSnapshotResponse } from '../models/RestoreSnapshotResponse';
import type { SyncClientsResponse } from '../models/SyncClientsResponse';
import type { UpdateSnapshotRequest } from '../models/UpdateSnapshotRequest';
import type { UpdateSnapshotResponse } from '../models/UpdateSnapshotResponse';
import type { WorkspaceCreate } from '../models/WorkspaceCreate';
import type { WorkspaceDelete } from '../models/WorkspaceDelete';
import type { WorkspaceHandleUpdate } from '../models/WorkspaceHandleUpdate';
import type { WorkspaceRename } from '../models/WorkspaceRename';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class DefaultService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get Boards
     * Returns all boards this user owns.
     * @returns GetBoardsResponse Successful Response
     * @throws ApiError
     */
    public getBoardsBoardsGet(): CancelablePromise<GetBoardsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/boards',
        });
    }

    /**
     * Get Board
     * Returns a board for this user.
     * @param boardId
     * @returns GetBoardResponse Successful Response
     * @throws ApiError
     */
    public getBoardBoardGet(
        boardId: string,
    ): CancelablePromise<GetBoardResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/board',
            query: {
                'board_id': boardId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Board
     * Creates a board for this user.
     * @param requestBody
     * @returns CreateBoardResponse Successful Response
     * @throws ApiError
     */
    public createBoardBoardPost(
        requestBody: CreateBoardRequest,
    ): CancelablePromise<CreateBoardResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/board',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Patch Board
     * Updates a board for this user.
     * @param requestBody
     * @returns PatchBoardResponse Successful Response
     * @throws ApiError
     */
    public patchBoardBoardPatch(
        requestBody: PatchBoardRequest,
    ): CancelablePromise<PatchBoardResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/board',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Board
     * Deletes a board for this user.
     * @param requestBody
     * @returns DeleteBoardResponse Successful Response
     * @throws ApiError
     */
    public deleteBoardBoardDelete(
        requestBody: DeleteBoardRequest,
    ): CancelablePromise<DeleteBoardResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/board',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Board Image Pins
     * Returns all board image pins for this user and board, if specified.
     * @param boardId
     * @param skip
     * @param limit
     * @returns GetBoardImagePinsResponse Successful Response
     * @throws ApiError
     */
    public getBoardImagePinsBoardImagePinsGet(
        boardId?: (string | null),
        skip?: number,
        limit: number = 100,
    ): CancelablePromise<GetBoardImagePinsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/board-image-pins',
            query: {
                'board_id': boardId,
                'skip': skip,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Board Image Pin
     * Creates a board image pin for this user.
     * @param requestBody
     * @returns CreateBoardImagePinResponse Successful Response
     * @throws ApiError
     */
    public createBoardImagePinBoardImagePinPost(
        requestBody: CreateBoardImagePinRequest,
    ): CancelablePromise<CreateBoardImagePinResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/board-image-pin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Board Image Pin
     * Deletes a board image pin for this user.
     * @param requestBody
     * @returns DeleteBoardImagePinResponse Successful Response
     * @throws ApiError
     */
    public deleteBoardImagePinBoardImagePinDelete(
        requestBody: DeleteBoardImagePinRequest,
    ): CancelablePromise<DeleteBoardImagePinResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/board-image-pin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Board Images
     * Returns all board images for this user and board.
     * @param boardId
     * @returns GetBoardImagesResponse Successful Response
     * @throws ApiError
     */
    public getBoardImagesBoardImagesGet(
        boardId: string,
    ): CancelablePromise<GetBoardImagesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/board-images',
            query: {
                'board_id': boardId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Chat Sessions
     * List all chat sessions for a graph project.
     * @param graphProjectId
     * @returns GetChatSessionsResponse Successful Response
     * @throws ApiError
     */
    public getChatSessionsGraphProjectGraphProjectIdChatSessionsGet(
        graphProjectId: string,
    ): CancelablePromise<GetChatSessionsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/graph-project/{graph_project_id}/chat-sessions',
            path: {
                'graph_project_id': graphProjectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Chat Messages
     * Get all messages in a chat session.
     * @param sessionId
     * @returns GetChatMessagesResponse Successful Response
     * @throws ApiError
     */
    public getChatMessagesChatSessionSessionIdMessagesGet(
        sessionId: string,
    ): CancelablePromise<GetChatMessagesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chat-session/{session_id}/messages',
            path: {
                'session_id': sessionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Chat Session
     * Delete a chat session and all its messages.
     * @param sessionId
     * @returns DeleteChatSessionResponse Successful Response
     * @throws ApiError
     */
    public deleteChatSessionChatSessionSessionIdDelete(
        sessionId: string,
    ): CancelablePromise<DeleteChatSessionResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/chat-session/{session_id}',
            path: {
                'session_id': sessionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Beta Info
     * @returns GetBetaInfoResponse Successful Response
     * @throws ApiError
     */
    public getBetaInfoBetaInfoGet(): CancelablePromise<GetBetaInfoResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/beta-info',
        });
    }

    /**
     * Get Early Access Invites
     * Gets all early access invites for this user.
     * @returns GetEarlyAccessInvitesResponse Successful Response
     * @throws ApiError
     */
    public getEarlyAccessInvitesEarlyAccessInvitesGet(): CancelablePromise<GetEarlyAccessInvitesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/early-access-invites',
        });
    }

    /**
     * Create Early Access Invite
     * Creates an early access invite for this user.
     * @param requestBody
     * @returns CreateEarlyAccessInviteResponse Successful Response
     * @throws ApiError
     */
    public createEarlyAccessInviteEarlyAccessInvitePost(
        requestBody: CreateEarlyAccessInviteRequest,
    ): CancelablePromise<CreateEarlyAccessInviteResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/early-access-invite',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Early Access Codes
     * The user's two personal give-to-a-friend codes, minted on first request.
     *
     * Only users who themselves have early access get codes, which is why the
     * gate lives here rather than at redemption: codes cannot exist for anyone
     * else.
     * @returns GetEarlyAccessCodesResponse Successful Response
     * @throws ApiError
     */
    public getEarlyAccessCodesEarlyAccessCodesGet(): CancelablePromise<GetEarlyAccessCodesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/early-access-codes',
        });
    }

    /**
     * Redeem Early Access Code
     * Redeem a single-use early access code, granting this user access.
     * @param requestBody
     * @returns RedeemEarlyAccessCodeResponse Successful Response
     * @throws ApiError
     */
    public redeemEarlyAccessCodeRedeemEarlyAccessCodePost(
        requestBody: RedeemEarlyAccessCodeRequest,
    ): CancelablePromise<RedeemEarlyAccessCodeResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/redeem-early-access-code',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Upload Aqueduct Asset
     * @param filename
     * @returns AssetUploadResponse Successful Response
     * @throws ApiError
     */
    public uploadAqueductAssetAqueductAssetsFilenamePut(
        filename: string,
    ): CancelablePromise<AssetUploadResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/aqueduct/assets/{filename}',
            path: {
                'filename': filename,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Upload Aqueduct Thumbnail
     * Snapshot/project preview thumbnails (separate namespace from /assets/).
     *
     * The 256px image is content-addressed by its own sha. The co-located 64px
     * "-64" variant is keyed off the 256's sha (so the frontend derives its URL)
     * and therefore cannot self-verify; it is validated as a small PNG instead.
     * @param filename
     * @returns AssetUploadResponse Successful Response
     * @throws ApiError
     */
    public uploadAqueductThumbnailAqueductThumbnailsFilenamePut(
        filename: string,
    ): CancelablePromise<AssetUploadResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/aqueduct/thumbnails/{filename}',
            path: {
                'filename': filename,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Graph Projects
     * @param workspaceId
     * @returns GetGraphProjectsResponse Successful Response
     * @throws ApiError
     */
    public getGraphProjectsGraphProjectsGet(
        workspaceId?: (string | null),
    ): CancelablePromise<GetGraphProjectsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/graph-projects',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Graph Project
     * @param graphProjectId
     * @returns GetGraphProjectResponse Successful Response
     * @throws ApiError
     */
    public getGraphProjectGraphProjectGraphProjectIdGet(
        graphProjectId: string,
    ): CancelablePromise<GetGraphProjectResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/graph-project/{graph_project_id}',
            path: {
                'graph_project_id': graphProjectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Rename Graph Project
     * @param graphProjectId
     * @param requestBody
     * @returns RenameGraphProjectResponse Successful Response
     * @throws ApiError
     */
    public renameGraphProjectGraphProjectGraphProjectIdPatch(
        graphProjectId: string,
        requestBody: RenameGraphProjectRequest,
    ): CancelablePromise<RenameGraphProjectResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/graph-project/{graph_project_id}',
            path: {
                'graph_project_id': graphProjectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Trash Graph Project
     * @param graphProjectId
     * @returns DeleteGraphProjectResponse Successful Response
     * @throws ApiError
     */
    public trashGraphProjectGraphProjectGraphProjectIdDelete(
        graphProjectId: string,
    ): CancelablePromise<DeleteGraphProjectResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/graph-project/{graph_project_id}',
            path: {
                'graph_project_id': graphProjectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Graph Project
     * @param requestBody
     * @returns CreateGraphProjectResponse Successful Response
     * @throws ApiError
     */
    public createGraphProjectGraphProjectPost(
        requestBody: CreateGraphProjectRequest,
    ): CancelablePromise<CreateGraphProjectResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/graph-project',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Restore Graph Project
     * @param graphProjectId
     * @param requestBody
     * @returns RestoreProjectResponse Successful Response
     * @throws ApiError
     */
    public restoreGraphProjectGraphProjectGraphProjectIdRestorePost(
        graphProjectId: string,
        requestBody?: (RestoreProjectRequest | null),
    ): CancelablePromise<RestoreProjectResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/graph-project/{graph_project_id}/restore',
            path: {
                'graph_project_id': graphProjectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Duplicate Project
     * @param graphProjectId
     * @param requestBody
     * @returns DuplicateSnapshotResponse Successful Response
     * @throws ApiError
     */
    public duplicateProjectGraphProjectGraphProjectIdDuplicatePost(
        graphProjectId: string,
        requestBody?: (DuplicateProjectRequest | null),
    ): CancelablePromise<DuplicateSnapshotResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/graph-project/{graph_project_id}/duplicate',
            path: {
                'graph_project_id': graphProjectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Restore Project From Snapshot
     * @param graphProjectId
     * @param snapshotId
     * @param requestBody
     * @returns RestoreProjectFromSnapshotResponse Successful Response
     * @throws ApiError
     */
    public restoreProjectFromSnapshotGraphProjectGraphProjectIdRestoreSnapshotSnapshotIdPost(
        graphProjectId: string,
        snapshotId: string,
        requestBody?: (RestoreProjectFromSnapshotRequest | null),
    ): CancelablePromise<RestoreProjectFromSnapshotResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/graph-project/{graph_project_id}/restore-snapshot/{snapshot_id}',
            path: {
                'graph_project_id': graphProjectId,
                'snapshot_id': snapshotId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Trashed Projects
     * @param workspaceId
     * @returns GetGraphProjectsResponse Successful Response
     * @throws ApiError
     */
    public getTrashedProjectsTrashProjectsGet(
        workspaceId: string,
    ): CancelablePromise<GetGraphProjectsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/trash/projects',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Trashed Snapshots
     * @param workspaceId
     * @returns GetTrashedSnapshotsResponse Successful Response
     * @throws ApiError
     */
    public getTrashedSnapshotsTrashSnapshotsGet(
        workspaceId: string,
    ): CancelablePromise<GetTrashedSnapshotsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/trash/snapshots',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Snapshot
     * @param graphProjectId
     * @param requestBody
     * @returns CreateSnapshotResponse Successful Response
     * @throws ApiError
     */
    public createSnapshotGraphProjectGraphProjectIdSnapshotPost(
        graphProjectId: string,
        requestBody: CreateSnapshotRequest,
    ): CancelablePromise<CreateSnapshotResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/graph-project/{graph_project_id}/snapshot',
            path: {
                'graph_project_id': graphProjectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Snapshots
     * @param graphProjectId
     * @returns GetSnapshotsResponse Successful Response
     * @throws ApiError
     */
    public getSnapshotsGraphProjectGraphProjectIdSnapshotsGet(
        graphProjectId: string,
    ): CancelablePromise<GetSnapshotsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/graph-project/{graph_project_id}/snapshots',
            path: {
                'graph_project_id': graphProjectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Snapshot
     * @param snapshotId
     * @returns GetSnapshotResponse Successful Response
     * @throws ApiError
     */
    public getSnapshotSnapshotSnapshotIdGet(
        snapshotId: string,
    ): CancelablePromise<GetSnapshotResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/snapshot/{snapshot_id}',
            path: {
                'snapshot_id': snapshotId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Snapshot
     * @param snapshotId
     * @param requestBody
     * @returns UpdateSnapshotResponse Successful Response
     * @throws ApiError
     */
    public updateSnapshotSnapshotSnapshotIdPatch(
        snapshotId: string,
        requestBody: UpdateSnapshotRequest,
    ): CancelablePromise<UpdateSnapshotResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/snapshot/{snapshot_id}',
            path: {
                'snapshot_id': snapshotId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Snapshot
     * @param snapshotId
     * @returns DeleteSnapshotResponse Successful Response
     * @throws ApiError
     */
    public deleteSnapshotSnapshotSnapshotIdDelete(
        snapshotId: string,
    ): CancelablePromise<DeleteSnapshotResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/snapshot/{snapshot_id}',
            path: {
                'snapshot_id': snapshotId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Restore Snapshot
     * @param snapshotId
     * @returns RestoreSnapshotResponse Successful Response
     * @throws ApiError
     */
    public restoreSnapshotSnapshotSnapshotIdRestorePost(
        snapshotId: string,
    ): CancelablePromise<RestoreSnapshotResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/snapshot/{snapshot_id}/restore',
            path: {
                'snapshot_id': snapshotId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Duplicate Snapshot
     * @param snapshotId
     * @param requestBody
     * @returns DuplicateSnapshotResponse Successful Response
     * @throws ApiError
     */
    public duplicateSnapshotSnapshotSnapshotIdDuplicatePost(
        snapshotId: string,
        requestBody?: (DuplicateSnapshotRequest | null),
    ): CancelablePromise<DuplicateSnapshotResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/snapshot/{snapshot_id}/duplicate',
            path: {
                'snapshot_id': snapshotId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Export Presets
     * @param workspaceId
     * @returns any Successful Response
     * @throws ApiError
     */
    public listExportPresetsWorkspaceWorkspaceIdExportPresetsGet(
        workspaceId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/workspace/{workspace_id}/export-presets',
            path: {
                'workspace_id': workspaceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Export Preset
     * @param workspaceId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public createExportPresetWorkspaceWorkspaceIdExportPresetsPost(
        workspaceId: string,
        requestBody: ExportPresetWrite,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/workspace/{workspace_id}/export-presets',
            path: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Export Preset
     * @param workspaceId
     * @param exportPresetId
     * @returns any Successful Response
     * @throws ApiError
     */
    public getExportPresetWorkspaceWorkspaceIdExportPresetsExportPresetIdGet(
        workspaceId: string,
        exportPresetId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/workspace/{workspace_id}/export-presets/{export_preset_id}',
            path: {
                'workspace_id': workspaceId,
                'export_preset_id': exportPresetId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Replace Export Preset
     * @param workspaceId
     * @param exportPresetId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public replaceExportPresetWorkspaceWorkspaceIdExportPresetsExportPresetIdPut(
        workspaceId: string,
        exportPresetId: string,
        requestBody: ExportPresetWrite,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/workspace/{workspace_id}/export-presets/{export_preset_id}',
            path: {
                'workspace_id': workspaceId,
                'export_preset_id': exportPresetId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Export Preset
     * @param workspaceId
     * @param exportPresetId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteExportPresetWorkspaceWorkspaceIdExportPresetsExportPresetIdDelete(
        workspaceId: string,
        exportPresetId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/workspace/{workspace_id}/export-presets/{export_preset_id}',
            path: {
                'workspace_id': workspaceId,
                'export_preset_id': exportPresetId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Sync Clients
     * @param graphProjectId
     * @returns SyncClientsResponse Successful Response
     * @throws ApiError
     */
    public getSyncClientsGraphProjectGraphProjectIdSyncClientsGet(
        graphProjectId: string,
    ): CancelablePromise<SyncClientsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/graph-project/{graph_project_id}/sync-clients',
            path: {
                'graph_project_id': graphProjectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Workspaces
     * @returns any Successful Response
     * @throws ApiError
     */
    public listWorkspacesWorkspacesGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/workspaces',
        });
    }

    /**
     * Create Workspace
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public createWorkspaceWorkspacesPost(
        requestBody: WorkspaceCreate,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/workspaces',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Rename Workspace
     * @param workspaceId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public renameWorkspaceWorkspaceWorkspaceIdPatch(
        workspaceId: string,
        requestBody: WorkspaceRename,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/workspace/{workspace_id}',
            path: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Workspace
     * @param workspaceId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteWorkspaceWorkspaceWorkspaceIdDelete(
        workspaceId: string,
        requestBody: WorkspaceDelete,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/workspace/{workspace_id}',
            path: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Workspace Handle
     * @param workspaceId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public updateWorkspaceHandleWorkspaceWorkspaceIdHandlePatch(
        workspaceId: string,
        requestBody: WorkspaceHandleUpdate,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/workspace/{workspace_id}/handle',
            path: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Members
     * @param workspaceId
     * @returns any Successful Response
     * @throws ApiError
     */
    public listMembersWorkspaceWorkspaceIdMembersGet(
        workspaceId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/workspace/{workspace_id}/members',
            path: {
                'workspace_id': workspaceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Change Member Role
     * @param workspaceId
     * @param memberUserId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public changeMemberRoleWorkspaceWorkspaceIdMemberMemberUserIdPatch(
        workspaceId: string,
        memberUserId: string,
        requestBody: MembershipRoleUpdate,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/workspace/{workspace_id}/member/{member_user_id}',
            path: {
                'workspace_id': workspaceId,
                'member_user_id': memberUserId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Remove Member
     * @param workspaceId
     * @param memberUserId
     * @returns any Successful Response
     * @throws ApiError
     */
    public removeMemberWorkspaceWorkspaceIdMemberMemberUserIdDelete(
        workspaceId: string,
        memberUserId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/workspace/{workspace_id}/member/{member_user_id}',
            path: {
                'workspace_id': workspaceId,
                'member_user_id': memberUserId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Leave Workspace
     * @param workspaceId
     * @returns any Successful Response
     * @throws ApiError
     */
    public leaveWorkspaceWorkspaceWorkspaceIdLeavePost(
        workspaceId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/workspace/{workspace_id}/leave',
            path: {
                'workspace_id': workspaceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Workspace Invitations
     * @param workspaceId
     * @returns any Successful Response
     * @throws ApiError
     */
    public listWorkspaceInvitationsWorkspaceWorkspaceIdInvitationsGet(
        workspaceId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/workspace/{workspace_id}/invitations',
            path: {
                'workspace_id': workspaceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Invitation
     * @param workspaceId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public createInvitationWorkspaceWorkspaceIdInvitationsPost(
        workspaceId: string,
        requestBody: InvitationCreate,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/workspace/{workspace_id}/invitations',
            path: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Resend Invitation
     * @param invitationId
     * @returns any Successful Response
     * @throws ApiError
     */
    public resendInvitationWorkspaceInvitationInvitationIdResendPost(
        invitationId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/workspace-invitation/{invitation_id}/resend',
            path: {
                'invitation_id': invitationId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Revoke Invitation
     * @param invitationId
     * @returns any Successful Response
     * @throws ApiError
     */
    public revokeInvitationWorkspaceInvitationInvitationIdDelete(
        invitationId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/workspace-invitation/{invitation_id}',
            path: {
                'invitation_id': invitationId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List My Invitations
     * @returns any Successful Response
     * @throws ApiError
     */
    public listMyInvitationsWorkspaceInvitationsGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/workspace-invitations',
        });
    }

    /**
     * Accept Invitation
     * @param invitationId
     * @returns any Successful Response
     * @throws ApiError
     */
    public acceptInvitationWorkspaceInvitationInvitationIdAcceptPost(
        invitationId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/workspace-invitation/{invitation_id}/accept',
            path: {
                'invitation_id': invitationId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Accept Invitation By Token
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public acceptInvitationByTokenWorkspaceInvitationAcceptPost(
        requestBody: InvitationTokenAccept,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/workspace-invitation/accept',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Decline Invitation
     * @param invitationId
     * @returns any Successful Response
     * @throws ApiError
     */
    public declineInvitationWorkspaceInvitationInvitationIdDeclinePost(
        invitationId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/workspace-invitation/{invitation_id}/decline',
            path: {
                'invitation_id': invitationId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Restore Workspace
     * @param workspaceId
     * @returns any Successful Response
     * @throws ApiError
     */
    public restoreWorkspaceWorkspaceWorkspaceIdRestorePost(
        workspaceId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/workspace/{workspace_id}/restore',
            path: {
                'workspace_id': workspaceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Generated Images
     * Gets generated images for the given parameters.
     * @param userId
     * @param saved
     * @param skip
     * @param limit
     * @param mostRecentFirst
     * @param generationIds
     * @param journeyId
     * @returns GetGeneratedImagesResponse Successful Response
     * @throws ApiError
     */
    public getGeneratedImagesGeneratedImagesGet(
        userId: string,
        saved: boolean = false,
        skip?: number,
        limit: number = 100,
        mostRecentFirst: boolean = true,
        generationIds?: (Array<string> | null),
        journeyId?: (string | null),
    ): CancelablePromise<GetGeneratedImagesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/generated-images',
            query: {
                'user_id': userId,
                'saved': saved,
                'skip': skip,
                'limit': limit,
                'most_recent_first': mostRecentFirst,
                'generation_ids': generationIds,
                'journey_id': journeyId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Patch Generated Images
     * Updates a generated image for this user.
     * @param requestBody
     * @returns PatchGeneratedImagesResponse Successful Response
     * @throws ApiError
     */
    public patchGeneratedImagesGeneratedImagesPatch(
        requestBody: PatchGeneratedImagesRequest,
    ): CancelablePromise<PatchGeneratedImagesResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/generated-images',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Generated Point Clouds
     * Gets generated point clouds for the given parameters.
     * @param userId
     * @param saved
     * @param skip
     * @param limit
     * @param mostRecentFirst
     * @param generationIds
     * @param journeyId
     * @returns GetGeneratedPointCloudsResponse Successful Response
     * @throws ApiError
     */
    public getGeneratedPointCloudsGeneratedPointCloudsGet(
        userId: string,
        saved: boolean = false,
        skip?: number,
        limit: number = 100,
        mostRecentFirst: boolean = true,
        generationIds?: (Array<string> | null),
        journeyId?: (string | null),
    ): CancelablePromise<GetGeneratedPointCloudsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/generated-point-clouds',
            query: {
                'user_id': userId,
                'saved': saved,
                'skip': skip,
                'limit': limit,
                'most_recent_first': mostRecentFirst,
                'generation_ids': generationIds,
                'journey_id': journeyId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Patch Generated Point Clouds
     * Updates a generated point cloud for this user.
     * @param requestBody
     * @returns PatchGeneratedPointCloudsResponse Successful Response
     * @throws ApiError
     */
    public patchGeneratedPointCloudsGeneratedPointCloudsPatch(
        requestBody: PatchGeneratedPointCloudsRequest,
    ): CancelablePromise<PatchGeneratedPointCloudsResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/generated-point-clouds',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Generated Point Cloud
     * Gets a generated point cloud for this user.
     * @param generationId
     * @returns GetGeneratedPointCloudResponse Successful Response
     * @throws ApiError
     */
    public getGeneratedPointCloudGeneratedPointCloudGet(
        generationId: string,
    ): CancelablePromise<GetGeneratedPointCloudResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/generated-point-cloud',
            query: {
                'generation_id': generationId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Vox File
     * Gets a vox file for this user.
     * @param generationId
     * @param gridSize
     * @param palette
     * @returns GetVoxFileResponse Successful Response
     * @throws ApiError
     */
    public getVoxFileVoxFileGet(
        generationId: string,
        gridSize: number,
        palette: string,
    ): CancelablePromise<GetVoxFileResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/vox-file',
            query: {
                'generation_id': generationId,
                'grid_size': gridSize,
                'palette': palette,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Glb File
     * Gets a glb file for this user.
     * @param generationId
     * @param gridSize
     * @returns GetGlbFileResponse Successful Response
     * @throws ApiError
     */
    public getGlbFileGlbFileGet(
        generationId: string,
        gridSize: number,
    ): CancelablePromise<GetGlbFileResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/glb-file',
            query: {
                'generation_id': generationId,
                'grid_size': gridSize,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Journeys
     * Returns all journeys this user owns.
     * @returns GetJourneysResponse Successful Response
     * @throws ApiError
     */
    public getJourneysJourneysGet(): CancelablePromise<GetJourneysResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/journeys',
        });
    }

    /**
     * Get Journey
     * Returns a journey for the given id.
     * @param journeyId
     * @returns GetJourneyResponse Successful Response
     * @throws ApiError
     */
    public getJourneyJourneyGet(
        journeyId: string,
    ): CancelablePromise<GetJourneyResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/journey',
            query: {
                'journey_id': journeyId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Journey
     * Creates a journey for this user.
     * @param requestBody
     * @returns CreateJourneyResponse Successful Response
     * @throws ApiError
     */
    public createJourneyJourneyPost(
        requestBody: CreateJourneyRequest,
    ): CancelablePromise<CreateJourneyResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/journey',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Patch Journey
     * Updates a journey for this user.
     * @param requestBody
     * @returns PatchJourneyResponse Successful Response
     * @throws ApiError
     */
    public patchJourneyJourneyPatch(
        requestBody: PatchJourneyRequest,
    ): CancelablePromise<PatchJourneyResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/journey',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Journey
     * Deletes a journey for this user.
     * @param requestBody
     * @returns DeleteJourneyResponse Successful Response
     * @throws ApiError
     */
    public deleteJourneyJourneyDelete(
        requestBody: DeleteJourneyRequest,
    ): CancelablePromise<DeleteJourneyResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/journey',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Materials
     * Gets PBR materials for the given parameters.
     * @param userId
     * @param skip
     * @param limit
     * @param mostRecentFirst
     * @param generationIds
     * @returns GetMaterialsResponse Successful Response
     * @throws ApiError
     */
    public getMaterialsMaterialsGet(
        userId: string,
        skip?: number,
        limit: number = 100,
        mostRecentFirst: boolean = true,
        generationIds?: (Array<string> | null),
    ): CancelablePromise<GetMaterialsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/materials',
            query: {
                'user_id': userId,
                'skip': skip,
                'limit': limit,
                'most_recent_first': mostRecentFirst,
                'generation_ids': generationIds,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Patch Materials
     * Updates a material for this user.
     * @param requestBody
     * @returns PatchMaterialsResponse Successful Response
     * @throws ApiError
     */
    public patchMaterialsMaterialsPatch(
        requestBody: PatchMaterialsRequest,
    ): CancelablePromise<PatchMaterialsResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/materials',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Material
     * Creates PBR material maps from a base image.
     * @param requestBody
     * @returns CreateMaterialResponse Successful Response
     * @throws ApiError
     */
    public createMaterialMaterialPost(
        requestBody: CreateMaterialRequest,
    ): CancelablePromise<CreateMaterialResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/material',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Connected Apps
     * @returns ConnectedAppsResponse Successful Response
     * @throws ApiError
     */
    public connectedAppsOauthConnectedAppsGet(): CancelablePromise<ConnectedAppsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/oauth/connected-apps',
        });
    }

    /**
     * Disconnect App
     * @param grantId
     * @returns void
     * @throws ApiError
     */
    public disconnectAppOauthConnectedAppsGrantIdDelete(
        grantId: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/oauth/connected-apps/{grant_id}',
            path: {
                'grant_id': grantId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Authorization Server Metadata
     * RFC 8414 authorization server metadata.
     * @returns any Successful Response
     * @throws ApiError
     */
    public authorizationServerMetadataWellKnownOauthAuthorizationServerGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/.well-known/oauth-authorization-server',
        });
    }

    /**
     * Register Client
     * RFC 7591 dynamic client registration. Public clients only.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public registerClientOauthRegisterPost(
        requestBody: any,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/oauth/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Authorize
     * OAuth 2.1 authorization endpoint.
     *
     * Validates the request, then hands off to the frontend consent page with
     * the request carried in a short-lived signed token. No pending-request
     * database row is created.
     * @returns any Successful Response
     * @throws ApiError
     */
    public authorizeOauthAuthorizeGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/oauth/authorize',
        });
    }

    /**
     * Consent Info
     * Describes a pending authorization request to the consent page.
     *
     * can_skip is true when the user already has a live grant for this client
     * with matching scopes, letting the page approve without rendering.
     * @param requestBody
     * @returns ConsentInfoResponse Successful Response
     * @throws ApiError
     */
    public consentInfoOauthConsentInfoPost(
        requestBody: ConsentInfoRequest,
    ): CancelablePromise<ConsentInfoResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/oauth/consent-info',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Consent Decision
     * Records the user's consent decision and mints an authorization code.
     *
     * Returns the client redirect URL; the consent page navigates there.
     * @param requestBody
     * @returns ConsentDecisionResponse Successful Response
     * @throws ApiError
     */
    public consentDecisionOauthConsentPost(
        requestBody: ConsentDecisionRequest,
    ): CancelablePromise<ConsentDecisionResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/oauth/consent',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Token Endpoint
     * OAuth 2.1 token endpoint (form-encoded). Public clients only.
     * @returns any Successful Response
     * @throws ApiError
     */
    public tokenEndpointOauthTokenPost(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/oauth/token',
        });
    }

    /**
     * Mcp Token
     * Mints an Aqueduct MCP access token for first-party agent infrastructure.
     *
     * The Aeolus bridge authenticates with its short-lived Agent credential and
     * receives an at+jwt token restricted to that credential's user and project.
     * The bridge injects it into its agent harness's MCP client configuration.
     *
     * There is no refresh token or grant row because this is first-party runtime
     * infrastructure, not a connected third-party OAuth client. The bridge
     * re-requests a token while its scoped runtime credential remains valid.
     * @returns any Successful Response
     * @throws ApiError
     */
    public mcpTokenOauthMcpTokenPost(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/oauth/mcp-token',
        });
    }

    /**
     * Jwks
     * Public signing keys: all non-retired keys plus recently retired ones.
     * @returns any Successful Response
     * @throws ApiError
     */
    public jwksOauthJwksJsonGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/oauth/jwks.json',
        });
    }

    /**
     * Get Plan Information
     * Gets information about the current plan.
     * @returns GetPlanInformationResponse Successful Response
     * @throws ApiError
     */
    public getPlanInformationPlanInformationGet(): CancelablePromise<GetPlanInformationResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/plan-information',
        });
    }

    /**
     * Get Presets
     * Returns presets that are either default or owned by the user,
     * along with the user's preset settings.
     * @returns GetPresetsResponse Successful Response
     * @throws ApiError
     */
    public getPresetsPresetsGet(): CancelablePromise<GetPresetsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/presets',
        });
    }

    /**
     * Patch Preset User Settings
     * Updates preset user settings for this user.
     * @param requestBody
     * @returns PatchPresetUserSettingsResponse Successful Response
     * @throws ApiError
     */
    public patchPresetUserSettingsPresetUserSettingsPatch(
        requestBody: PatchPresetUserSettingsRequest,
    ): CancelablePromise<PatchPresetUserSettingsResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/preset-user-settings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Prompt Addendums
     * Returns all prompt addendums.
     * @returns GetPromptAddendumsResponse Successful Response
     * @throws ApiError
     */
    public getPromptAddendumsPromptAddendumsGet(): CancelablePromise<GetPromptAddendumsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/prompt-addendums',
        });
    }

    /**
     * Create Prompt Addendum
     * Creates a prompt addendum for this user.
     * @param requestBody
     * @returns CreatePromptAddendumResponse Successful Response
     * @throws ApiError
     */
    public createPromptAddendumPromptAddendumPost(
        requestBody: CreatePromptAddendumRequest,
    ): CancelablePromise<CreatePromptAddendumResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/prompt-addendum',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Prompt Addendum
     * Deletes a prompt addendum for this user.
     * @param requestBody
     * @returns DeletePromptAddendumResponse Successful Response
     * @throws ApiError
     */
    public deletePromptAddendumPromptAddendumDelete(
        requestBody: DeletePromptAddendumRequest,
    ): CancelablePromise<DeletePromptAddendumResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/prompt-addendum',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Patch Prompt Addendum
     * Updates a prompt addendum for this user.
     * @param requestBody
     * @returns PatchPromptAddendumResponse Successful Response
     * @throws ApiError
     */
    public patchPromptAddendumPromptAddendumPatch(
        requestBody: PatchPromptAddendumRequest,
    ): CancelablePromise<PatchPromptAddendumResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/prompt-addendum',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Append Run Log Event
     * Append a single event line to <run_id>.jsonl. Body is the event JSON,
     * written verbatim as one line. If the file is new, prune the directory
     * to the LRU cap.
     * @param runId
     * @returns any Successful Response
     * @throws ApiError
     */
    public appendRunLogEventRunLogsRunIdEventPost(
        runId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/run-logs/{run_id}/event',
            path: {
                'run_id': runId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Append Run Log Events
     * Append a batch of event lines to <run_id>.jsonl. Body is a JSON array
     * of event JSON values. The stored format remains one event per JSONL line.
     * @param runId
     * @returns any Successful Response
     * @throws ApiError
     */
    public appendRunLogEventsRunLogsRunIdEventsPost(
        runId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/run-logs/{run_id}/events',
            path: {
                'run_id': runId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Uploaded Images
     * Gets uploaded images for the given parameters.
     * @param userId
     * @param skip
     * @param limit
     * @param mostRecentFirst
     * @param uploadIds
     * @param journeyId
     * @returns GetUploadedImagesResponse Successful Response
     * @throws ApiError
     */
    public getUploadedImagesUploadedImagesGet(
        userId: string,
        skip?: number,
        limit: number = 100,
        mostRecentFirst: boolean = true,
        uploadIds?: (Array<string> | null),
        journeyId?: (string | null),
    ): CancelablePromise<GetUploadedImagesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/uploaded-images',
            query: {
                'user_id': userId,
                'skip': skip,
                'limit': limit,
                'most_recent_first': mostRecentFirst,
                'upload_ids': uploadIds,
                'journey_id': journeyId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Patch Uploaded Images
     * Updates an uploaded image for this user.
     * @param requestBody
     * @returns PatchUploadedImagesResponse Successful Response
     * @throws ApiError
     */
    public patchUploadedImagesUploadedImagesPatch(
        requestBody: PatchUploadedImagesRequest,
    ): CancelablePromise<PatchUploadedImagesResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/uploaded-images',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Uploaded Image
     * Creates an uploaded image for this user.
     * @param requestBody
     * @returns CreateUploadedImageResponse Successful Response
     * @throws ApiError
     */
    public createUploadedImageUploadedImagePost(
        requestBody: CreateUploadedImageRequest,
    ): CancelablePromise<CreateUploadedImageResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/uploaded-image',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get User Settings
     * @returns GetUserSettingsResponse Successful Response
     * @throws ApiError
     */
    public getUserSettingsUserSettingsGet(): CancelablePromise<GetUserSettingsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user-settings',
        });
    }

    /**
     * Patch User Settings
     * Updates the user settings for this user.
     * @param requestBody
     * @returns PatchUserSettingsResponse Successful Response
     * @throws ApiError
     */
    public patchUserSettingsUserSettingsPatch(
        requestBody: PatchUserSettingsRequest,
    ): CancelablePromise<PatchUserSettingsResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/user-settings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Diffusion Job
     * Creates a diffusion job info resource.
     * Deletes any previously existing job info resources and associated images.
     * @param requestBody
     * @returns CreateDiffusionJobInfoResponse Successful Response
     * @throws ApiError
     */
    public createDiffusionJobDiffusionJobInfoPost(
        requestBody: CreateDiffusionJobInfoRequest,
    ): CancelablePromise<CreateDiffusionJobInfoResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/diffusion-job-info',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
